import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { CoverageListsPanel } from '@/components/reports/CoverageListsPanel'
import { accountQuery, coverageListsQuery, sessionQuery } from '@/lib/queries'
import { isStaff } from '@/lib/viewer'

/**
 * An account's Coverage lists — its own named outlet/country/language sets (and the global built-ins,
 * read-only). A Resources surface like Topics and Templates; the full manager lives in
 * CoverageListsPanel. Global lists are editable only for staff (the API reserves them), so a customer
 * manages just their account's lists here and curates globals on the internal /app/lists library.
 */
export const Route = createFileRoute('/app/accounts/$accountId_/coverage-lists/')({
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(accountQuery(params.accountId)),
      context.queryClient.ensureQueryData(coverageListsQuery(params.accountId)),
    ]),
  component: AccountCoverageListsPage,
})

function AccountCoverageListsPage() {
  const { accountId } = Route.useParams()
  const { data: session } = useSuspenseQuery(sessionQuery)
  return <CoverageListsPanel accountId={accountId} canManageGlobals={isStaff(session.user)} />
}
